export function getObjectDiff(obj1: any, obj2: any): null | any {
    if (obj1 === obj2) return null; // No difference

    if (
        typeof obj1 !== 'object' ||
        typeof obj2 !== 'object' ||
        obj1 === null ||
        obj2 === null
    ) {
        return { old: obj1, new: obj2 }; // Primitive value changed
    }

    const diff: Record<string, any> = {};
    const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    keys.forEach((key) => {
        if (!(key in obj1)) {
            diff[key] = { added: obj2[key] }; // New key in obj2
        } else if (!(key in obj2)) {
            diff[key] = { removed: obj1[key] }; // Key removed from obj2
        } else {
            const subDiff = getObjectDiff(obj1[key], obj2[key]);
            if (subDiff !== null) {
                diff[key] = subDiff; // Store only changed parts
            }
        }
    });

    return Object.keys(diff).length ? diff : null;
}
